// src/ecrans/voyageurs/voyageurs-calculs.js — Voyageurs NEST : la liste des
// conversations depuis `ecran_conversations_lire` (fonctions pures, testées).

import { jourCourt } from "../nest";

/** Le filtre de la barre (Tous · Non lus · À traiter · Aujourd'hui). */
export function filtrerFils(fils, { filtre, texte, logement }, today) {
  const q = String(texte || "").trim().toLowerCase();
  return (fils || []).filter((f) => {
    if (filtre === "non_lus" && !(f.non_lus > 0)) return false;
    if (filtre === "a_traiter" && !f.a_traiter) return false;
    if (filtre === "aujourdhui" && !estDuJour(f, today)) return false;
    if (logement && (!f.logement || f.logement.id !== logement)) return false;
    if (q) {
      const tx = `${f.voyageur || ""} ${(f.logement && f.logement.nom) || ""} ${f.extrait || ""}`.toLowerCase();
      if (!tx.includes(q)) return false;
    }
    return true;
  });
}

/** Un fil « d'aujourd'hui » : le voyageur arrive, part ou a écrit aujourd'hui. */
export function estDuJour(f, today) {
  const s = f.sejour;
  if (s && (s.arrivee === today || s.depart === today)) return true;
  return Boolean(f.dernier_a && jourParis(f.dernier_a) === today);
}

export function jourParis(iso) {
  return new Intl.DateTimeFormat("en-CA", { timeZone: "Europe/Paris" }).format(new Date(iso));
}

/** « 11h10 » aujourd'hui, « hier », sinon « 21 août ». */
export function quand(iso, today) {
  if (!iso || Number.isNaN(Date.parse(iso))) return "";
  const j = jourParis(iso);
  if (j === today) {
    const h = new Intl.DateTimeFormat("fr-FR", { timeZone: "Europe/Paris", hour: "2-digit", minute: "2-digit" })
      .format(new Date(iso))
      .replace(":", "h");
    return h.replace(/^0/, "");
  }
  const hier = new Date(Date.parse(`${today}T12:00:00Z`) - 86400000).toISOString().slice(0, 10);
  if (j === hier) return "hier";
  return jourCourt(j);
}

/** La ligne du séjour sous le nom : ↑ arrive / ↓ part / en séjour / parti. */
export function ligneSejour(s, today) {
  if (!s || !s.arrivee) return null;
  if (s.statut && /cancel|annul/i.test(s.statut)) return { sens: "", texte: "séjour annulé", ton: "gris" };
  if (s.arrivee === today) return { sens: "↑", texte: "arrive aujourd'hui", ton: "vert" };
  if (s.depart === today) return { sens: "↓", texte: "part aujourd'hui", ton: "aub" };
  if (s.arrivee > today) return { sens: "↑", texte: `arrive le ${jourCourt(s.arrivee)}`, ton: "bleu" };
  if (s.depart && s.depart < today) return { sens: "", texte: `parti le ${jourCourt(s.depart)}`, ton: "gris" };
  return { sens: "", texte: `en séjour · jusqu'au ${jourCourt(s.depart)}`, ton: "vert" };
}

/** Les initiales d'un nom (« Marta Roig » → « MR »). */
export function initiales(nom) {
  const p = String(nom || "").trim().split(/\s+/).filter(Boolean);
  if (!p.length) return "?";
  return (p[0][0] + (p.length > 1 ? p[p.length - 1][0] : "")).toUpperCase();
}

const LETTRES = { airbnb: "A", booking: "B", direct: "D" };

/** La lettre de la plateforme sur l'avatar (rendue par la porte) ; inconnue : « — ». */
export function lettrePlateforme(plateforme) {
  return LETTRES[plateforme] || "—";
}

/** Le lundi de la semaine de `today`, « AAAA-MM-JJ ». */
export function lundiDe(today) {
  const d = new Date(`${today}T12:00:00Z`);
  const recul = (d.getUTCDay() + 6) % 7;
  d.setUTCDate(d.getUTCDate() - recul);
  return d.toISOString().slice(0, 10);
}
